type AttachmentTripRatingProps = {
  imageSrc?: string | null;
  fileType?: string | null;
};
export const AttachmentTripRating: React.FC<AttachmentTripRatingProps> = ({
  imageSrc,
  fileType
}) => {
  return (
    <>
      <div className="flex items-center">
        {fileType === "pdf" ? (
          <iframe
            src={imageSrc || ""}
            title="Uploaded PDF"
            className="h-[500px] w-full border-none"
          />
        ) : fileType === "image" ? (
          <img
            src={imageSrc || ""}
            alt="Uploaded File"
            className="max-h-[500px] w-full object-contain"
          />
        ) : (
          <p>Preview not available for this file type.</p>
        )}
      </div>
    </>
  );
};
